import React, {useEffect, useState} from 'react';
import axios from "axios";
import fernet from 'fernet';
import Search from "./Components/Search";
import PromoBanners from "./Components/PromoBanners";
import TopThemes from "./Components/TopThemes";
import ThemeInfo from "./Components/ThemeInfo";
import StoreInfo from "./Components/StoreInfo";
import './App.less';

const secret = new fernet.Secret('uV7HJdHDlqqJN6Fuyl8ulILoGSeccbyCpr6h3wBerpw=');
const generateToken = () => new fernet.Token({secret: secret, time: Date.parse(new Date())});

export const encryptedData = (data) => {
    let encrypted = generateToken().encode(JSON.stringify(data));
    return ({encrypted});
};

function App() {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const [result, setResult] = useState(null);
    const [initialUrl, setInitialUrl] = useState('');

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);

        const urlParams = new URLSearchParams(window.location.search);
        const urlParam = urlParams.get('url');
        if (urlParam) {
            setInitialUrl(urlParam);
            handleSubmit(urlParam);
            try {
                const newUrl = window.location.origin + window.location.pathname;
                window.history.replaceState({}, document.title, newUrl);
            } catch (e) {
                console.error('Failed to update history state', e);
            }
        }

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    async function getMetaData(link) {
        try {
            return await axios.get(
                `https://api-ws-extension.prod.dropship.io/api/proxy/?target_url=${encodeURIComponent(`${link}/meta.json`)}`,
                {
                    headers: {
                        "Extension-User-Token": "8692465325073239635",
                        "Extension-Token": 'sdfkljsbdfgoipoasji2318743460r9edlfgjhpre896544534854368tfd34lfgkjbpfgepofdgsoidfsopdfjspodfjsidfjgphjmweorwjeoir5487623423jkdflgdkf874538953459834'
                    }
                }
            )
                .then(res => {
                    const data = res?.data;
                    if (data?.['published_products_count']) {
                        return {...data};
                    } else {
                        throw new Error('This link does not seem to be a Shopify store.');
                    }
                })
        } catch (e) {
            setError('This link does not seem to be a Shopify store.');
            setLoading(false);
            return null;
        }
    }

    async function checkExistence(data) {
        try {
            return await axios.post('https://api.dropship.io/api/shopify-extension/existence-check/',
                encryptedData({
                    'shopify_shop_id': data?.id,
                    'custom_domain': data?.domain,
                    'shopify_domain': data?.myshopify_domain
                }), {
                    headers: {
                        "Extension-User-Token": "8692465325073239635",
                        "Extension-Token": 'sdfkljsbdfgoipoasji2318743460r9edlfgjhpre896544534854368tfd34lfgkjbpfgepofdgsoidfsopdfjspodfjsidfjgphjmweorwjeoir5487623423jkdflgdkf874538953459834'
                    }
                })
                .then(res => res.data)
        } catch (e) {
            setError('Please, try again later with this shop');
            setLoading(false);
            return null;
        }
    }

    async function getPaymentData(link) {
        try {
            return await axios.get(
                `https://api-ws-extension.prod.dropship.io/api/proxy/?target_url=${encodeURIComponent(`${link}/payments/config`)}`,
                {
                    headers: {
                        "Extension-User-Token": "8692465325073239635",
                        "Extension-Token": 'sdfkljsbdfgoipoasji2318743460r9edlfgjhpre896544534854368tfd34lfgkjbpfgepofdgsoidfsopdfjspodfjsidfjgphjmweorwjeoir5487623423jkdflgdkf874538953459834'
                    }
                }
            )
                .then(async res => {
                    const paymentsConfigData = res?.data;
                    const token = paymentsConfigData?.paymentInstruments?.accessToken;
                    const graphqlQuery = `
                  query Shop {
                    shop {
                      description
                      id
                      moneyFormat
                      name
                      shipsToCountries
                      brand {
                        shortDescription
                        slogan
                        colors {
                          primary {
                            background
                            foreground
                          }
                        }
                        logo {
                          alt
                          id
                          mediaContentType
                          image {
                            altText
                            height
                            id
                            originalSrc
                            src
                            transformedSrc
                            url
                            width
                          }
                        }
                        coverImage {
                          alt
                          id
                          mediaContentType
                        }
                        squareLogo {
                          alt
                          id
                          mediaContentType
                        }
                      }
                      paymentSettings {
                        acceptedCardBrands
                        cardVaultUrl
                        countryCode
                        currencyCode
                        enabledPresentmentCurrencies
                        shopifyPaymentsAccountId
                        supportedDigitalWallets
                      }
                      primaryDomain {
                        host
                        sslEnabled
                        url
                      }
                      privacyPolicy {
                        body
                        handle
                        id
                        title
                        url
                      }
                      refundPolicy {
                        body
                        handle
                        id
                        title
                        url
                      }
                      shippingPolicy {
                        body
                        handle
                        id
                        title
                        url
                      }
                      subscriptionPolicy {
                        body
                        handle
                        id
                        title
                        url
                      }
                      termsOfService {
                        body
                        handle
                        id
                        title
                        url
                      }
                    }
                    productTypes(first: 250) {
                      nodes
                    }
                    localization {
                      availableLanguages {
                        endonymName
                        isoCode
                        name
                      }
                      country {
                        isoCode
                        name
                        unitSystem
                        availableLanguages {
                          endonymName
                          isoCode
                          name
                        }
                        currency {
                          isoCode
                          name
                          symbol
                        }
                        defaultLanguage {
                          endonymName
                          isoCode
                          name
                        }
                      }
                      language {
                        endonymName
                        isoCode
                        name
                      }
                      market {
                        handle
                        id
                      }
                    }
                    paymentSettings {
                      acceptedCardBrands
                      cardVaultUrl
                      countryCode
                      currencyCode
                      enabledPresentmentCurrencies
                      shopifyPaymentsAccountId
                      supportedDigitalWallets
                    }
                  }
                `;

                    try {
                        return await axios.post(
                            `${link}/api/2025-04/graphql.json`,
                            JSON.stringify({
                                query: graphqlQuery,
                            }),
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-Shopify-Storefront-Access-Token': token,
                                },
                            }
                        )
                            .then(res => ({...res.data?.data, paymentsConfig: paymentsConfigData}));

                    } catch (e) {
                        setError('Sorry, something went wrong. Please, try again later.');
                        setLoading(false);
                    }
                });
        } catch (e) {
            setError('Sorry, something went wrong. Please, try again later.');
            setLoading(false);
            return null;
        }
    }

    async function getStoreInternalData(data) {
        try {
            return await axios.get(`https://api.dropship.io/api/shopify-extension/stores/${data?.internal_shop_id}/info/`, {
                headers: {
                    "Extension-User-Token": "8692465325073239635",
                    "Extension-Token": 'sdfkljsbdfgoipoasji2318743460r9edlfgjhpre896544534854368tfd34lfgkjbpfgepofdgsoidfsopdfjspodfjsidfjgphjmweorwjeoir5487623423jkdflgdkf874538953459834'
                }
            })
                .then(res => res.data)
        } catch (e) {
            setError('Sorry, something went wrong. Please, try again later.');
            setLoading(false);
            return null;
        }
    }

    async function getThemeInfo(link) {
        try {
            return await axios.post('https://api.dropship.io/api/shopify-extension/theme-detector/',
                encryptedData({
                    'domain': link,
                }), {
                    headers: {
                        "Extension-User-Token": "8692465325073239635",
                        "Extension-Token": 'sdfkljsbdfgoipoasji2318743460r9edlfgjhpre896544534854368tfd34lfgkjbpfgepofdgsoidfsopdfjspodfjsidfjgphjmweorwjeoir5487623423jkdflgdkf874538953459834'
                    }
                })
                .then(res => res.data)
        } catch (e) {
            setError('Please, try again later with this shop');
            setLoading(false);
            return null;
        }
    }

    async function getStoreImage(link) {
        try {
            return await axios.get(
                `https://api-ws-extension.prod.dropship.io/api/proxy/?target_url=${encodeURIComponent(`https://s.wordpress.com/mshots/v1/${link}`)}`,
                {
                    responseType: 'arraybuffer',
                    headers: {
                        "Extension-User-Token": "8692465325073239635",
                        "Extension-Token": 'sdfkljsbdfgoipoasji2318743460r9edlfgjhpre896544534854368tfd34lfgkjbpfgepofdgsoidfsopdfjspodfjsidfjgphjmweorwjeoir5487623423jkdflgdkf874538953459834'
                    }
                }
            )
                .then(res => {
                    const base64 = btoa(
                        new Uint8Array(res.data)
                            .reduce((data, byte) => data + String.fromCharCode(byte), '')
                    );
                    return `data:image/gif;base64,${base64}`;
                });
        } catch(e) {
            setLoading(false);
            return null;
        }
    }

    async function handleSubmit(value) {
        if (!value) return;
        let correctValue = value?.includes('http') || value?.includes('https') ? value : ('https://' + value);
        let url;
        try {
            url = new URL(correctValue)?.origin;
        } catch (e) {
            setError('This link does not seem to be a Shopify store.');
            return;
        }
        setLoading(true);
        const metaData = await getMetaData(url);
        if (metaData && metaData['published_products_count']) {
            const existenceData = await checkExistence(metaData);
            if (existenceData?.internal_shop_id) {
                const paymentData = await getPaymentData(url);
                if (paymentData?.shop) {
                    const storeInternalData = await getStoreInternalData(existenceData);
                    if (storeInternalData?.store_info) {
                        const themeInfo = await getThemeInfo(url);
                        if (themeInfo?.status) {
                            const storeImage = await getStoreImage(url);
                            setResult({
                                metaData,
                                existenceData,
                                paymentData,
                                storeInternalData,
                                storeImage,
                                themeInfo,
                            });
                            setLoading(false);
                        }
                    }
                }
            }
        }
    }

    return (
        <div className="main-container">
            <div className="title-text">
                <h3>
                    Shopify Theme Detector
                </h3>
                <p>
                    Discover any store’s Shopify theme and key store details - just paste the URL for instant results.
                </p>
            </div>
            <Search loading={loading}
                    submit={handleSubmit}
                    isMobile={isMobile}
                    error={error}
                    setError={setError}
                    initialUrl={initialUrl}
            />
            {
                result || loading ?
                    null
                    :
                    <PromoBanners/>
            }
            {
                result || loading ?
                    null
                    :
                    <TopThemes isMobile={isMobile}
                               skeleton={false}
                    />
            }
            {
                result || loading ?
                    <ThemeInfo skeleton={loading}
                               isMobile={isMobile}
                               result={result}
                    />
                    :
                    null
            }
            {
                result || loading ?
                    <StoreInfo skeleton={loading}
                               result={result}
                    />
                    :
                    null
            }
        </div>
    );
}

export default App;
